import { render } from "./Websocket.vue?vue&type=template&id=25f29841"
import script from "./Websocket.vue?vue&type=script&lang=js"
export * from "./Websocket.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__